import { FileImageMarkerOutlineIcon } from './FileImageMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id BE46BBCE-2872-4DBE-976E-AC9BC2CE19D3
 * name file-image-marker-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-image-marker-outline.svg
 * tags
 * - Files / Folders 
 * - Navigation 
 */
export const FileImageLocationOutlineIcon = FileImageMarkerOutlineIcon;
export default FileImageLocationOutlineIcon